import {Link} from '@inertiajs/react';
import {forwardRef, memo} from 'react';

const InertiaLink = forwardRef(({children, href, method, component, centerRipple, focusRipple, external, ...props}, ref) => {
    // Si c'est un lien externe, utiliser un lien HTML natif
    if (external) {
        return (
            <a href={href} {...props} ref={ref}>
                {children}
            </a>
        );
    }
    
    // Sinon, utiliser Inertia Link normalement
    return (
        <Link href={href} method={method ?? 'get'} {...props} as="button">
            {children}
        </Link>
    );
});

export default memo(InertiaLink);
